export default __webpack_public_path__ + "static/media/GearCampus.f91344d7.jpg";